/**
 * Operator support session on a tenant host (A3, identity contract §7). The operator console opens
 * `https://{slug}.<domain>/?support-session=<id>`; the id (not a credential) is kept for this browser tab only and
 * sent as `X-Positive-Support-Session` with the operator's token.
 */
export const supportSessionParam = "support-session";
const storageKey = "positive.supportSession";
const idPattern = /^[0-9a-zA-Z-]{8,64}$/u;

export function readSupportSession(
  search: string,
  storage: Pick<Storage, "getItem" | "setItem"> | null,
): string | null {
  const fromUrl = new URLSearchParams(search).get(supportSessionParam);
  try {
    if (fromUrl !== null && idPattern.test(fromUrl)) {
      storage?.setItem(storageKey, fromUrl);
      return fromUrl;
    }
    const stored = storage?.getItem(storageKey) ?? null;
    return stored !== null && idPattern.test(stored) ? stored : null;
  } catch {
    return fromUrl !== null && idPattern.test(fromUrl) ? fromUrl : null;
  }
}

export function clearSupportSession(storage: Pick<Storage, "removeItem"> | null): void {
  try {
    storage?.removeItem(storageKey);
  } catch {
    // Storage unavailable: nothing was stored.
  }
}
